export const SWITCH_PREVIEW_STATE_HOST = 'SWITCH_PREVIEW_STATE_HOST' as const;

export type SwitchPreviewStateAction = {
    type: 'SWITCH_PREVIEW_STATE_HOST',
    payload: string
};
